export const FEATURES = {
  WEATHER: 'weather',
  CALENDAR: 'calendar',
  TASKS: 'tasks',
  LIVESTOCK: 'livestock',
  GROUPS: 'groups',
  FARMS: 'farms',
  GEOFENCES: 'geofences',
  SITES: 'sites',
  BREEDING: 'breeding',
  TREATMENT: 'treatment',
  MEASURES: 'measures',
  NOTIFICATIONS: 'notifications',
  SMS: 'sms',
  RULES: 'rules',
  TRACK_LIVESTOCK: 'track_livestock',
  TAGS: 'tags',
  GATEWAYS: 'gateways'
};
